var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6525 2.5C7.98625 2.50188 8.82125 2.51 9.70875 2.54562L10.0238 2.55937C10.9169 2.60125 11.8094 2.67375 12.2525 2.79687C12.8431 2.96312 13.3069 3.44688 13.4637 4.06063C13.7137 5.03562 13.745 6.93688 13.7487 7.3975L13.7494 7.4925V7.60125C13.745 8.06187 13.7137 9.96375 13.4637 10.9381C13.305 11.5538 12.8406 12.0381 12.2525 12.2019C11.8094 12.325 10.9169 12.3975 10.0238 12.4394L9.70875 12.4538C8.82125 12.4888 7.98625 12.4975 7.6525 12.4987L7.50562 12.4994H7.34625C6.64 12.495 3.68625 12.4631 2.74625 12.2019C2.15625 12.0356 1.69188 11.5519 1.535 10.9381C1.285 9.96312 1.25375 8.06187 1.25 7.60125V7.3975C1.25375 6.93688 1.285 5.035 1.535 4.06063C1.69375 3.445 2.15812 2.96062 2.74688 2.7975C3.68625 2.53562 6.64062 2.50375 7.34688 2.5H7.6525ZM6.24937 5.3125V9.6875L9.99937 7.5L6.24937 5.3125Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.6eb580282d2ac783e4b0498e54339822.svg";
export { ForwardRef as ReactComponent };